import React from 'react';

import Button from 'components/Button';

import { useTracking } from 'hooks/useTracking';

const ShowFullCatalogButton = () => {
  const { trackContentInteraction } = useTracking();

  return (
    <Button
      title={{ id: 'containers.ShowFullCatalog.button' }}
      variant="secondary"
      linkTo={'/explore/all?title='}
      onClick={() =>
        trackContentInteraction('click', 'catalog', 'catalog-button')
      }
    />
  );
};

export default ShowFullCatalogButton;
